<template>
  <div>
    <v-select
      :items="items"
      :disabled="isDisabled"
      v-model="selectedStatusId"
      label="Status"
      item-text="name"
      item-value="id"
      @change="onChange($event)"
      :outlined="outlined"
    ></v-select>
  </div>
</template>

<script>
import { SERVICE_STATUSES_LIST } from "../../../constants/graphql";
export default {
  name: "ServiceStatusListSelect",
  props: {
    outlined: {
      type: Boolean,
      default: () => false,
    },
    serviceStatusId: {
      type: String,
      default: () => "U2VydmljZVN0YXR1cy0x",
    },
    isDisabled: {
      type: Boolean,
      default: () => true,
    },
    serviceStatusName: {
      type: String,
      default: () => "",
    },
    value: {
      type: String,
      default: () => "",
    },
    // #11287 part 1: when set to a non-empty array of status names, the dropdown
    // is restricted to those statuses only (e.g. seller MP service → Confirmed/Rejected).
    allowedStatusNames: {
      type: Array,
      default: () => null,
    },
  },
  data() {
    return {
      allStatuses: [{ name: "Quotation", id: "1" }],
      selectedStatusId:
        this.value != ""
          ? this.value
          : this.serviceStatusId
          ? this.serviceStatusId
          : "U2VydmljZVN0YXR1cy0x",
      serviceStatuses: {},
    };
  },
  computed: {
    // #11287 part 1: filter to allowedStatusNames when provided (an empty array
    // means no statuses are allowed), else show all.
    items() {
      if (Array.isArray(this.allowedStatusNames)) {
        return this.allStatuses.filter((s) =>
          this.allowedStatusNames.includes(s.name)
        );
      }
      return this.allStatuses;
    },
  },
  methods: {
    onChange(e) {
      if (typeof e == "string") {
        var selectedItem = this.items.find((item) => item.id == e);
        this.$emit("onSelect", selectedItem);
        this.$emit("input", selectedItem.id);
      }
    },
  },
  watch: {
    serviceStatusId: function (val) {
      this.selectedStatusId = val;
    },
    value(newVal) {
      this.statusId = newVal;
    },
  },
  apollo: {
    serviceStatuses: {
      query: SERVICE_STATUSES_LIST,
      result({ data }) {
        this.allStatuses = data.serviceStatuses.edges.map((node) => ({
          ...node.node,
        }));
      },
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/shared/ServiceStatusListSelect.vue